import { useCallback, useMemo, useSyncExternalStore } from "react";
import { isBrowser } from "../isBrowser";

export const useMatchMedia = (mediaQuery: string, initialState = false) => {
  const matchMediaList = useMemo(() => {
    return isBrowser ? window.matchMedia(mediaQuery) : undefined;
  }, [mediaQuery]);

  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      matchMediaList?.addEventListener("change", onStoreChange);
      return () => matchMediaList?.removeEventListener("change", onStoreChange);
    },
    [matchMediaList],
  );

  return useSyncExternalStore(
    subscribe,
    () => matchMediaList?.matches ?? initialState,
    () => initialState,
  );
};
